<div class="sub-header">
  <div class="container" >
    <nav class="navbar navbar-expand-lg" [ngClass]="{'navbar-special': currentRoute === '/', 'navbar-other': currentRoute !== '/'}">
      <div class="container-fluid">
        <span class="pe-0">
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navContent" aria-controls="navContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
        </span>
        @if(!hideLearnMore){
          <div class="navbar-brand">
            <span class="office-name" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
              <a href="/"><img src="assets/images/sgdpLogo.png" width="138" height="48" alt=""></a>
            </span>
          </div>
        } @else {
          <div class="navbar-brand">
            <span class="office-name" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
              <a href="/adha"><img src="assets/images/adha_logo.png" width="250" height="38" alt=""></a>
            </span>
          </div>
        }

        <a href="tel:{{this.info.telephoneNumber}}" class="phone">
          <img class="logo" src="assets/images/phone-black.png" (click)="onCall()" alt="phone icon"/>
        </a>
        <div class="spacer">&nbsp;</div>
        <div class="collapse navbar-collapse" id="navContent">
          <ul class="navbar-nav" style="width:100%">
            <li class="nav-item mt-3 me-3">
              <a id="find-a-dentist" class="sub-header-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" routerLink="{{findADentistLink}}" (click)="findDentist()">find a dentist</a>
            </li>
            <li class="nav-item mt-3 me-4" *ngIf="!hideLearnMore">
              <a id="invite-button" class="sub-header-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" (click)="inviteAFriend()">learn more</a>
            </li>
            <li class="nav-item mt-3 me-4">
              <a id="member-support-link" class="sub-header-link" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" style="min-width: 75px;" routerLink="{{supportLink}}">SUPPORT</a>
            </li>
            <li class="nav-item mt-2">
              <a id="member-login-link" class="btn btn-lg member-login" style="font-size:18px;" href="{{environment.memberPortalLink}}" target="_blank" (click)="memberLogin()">MEMBER LOGIN</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>
